import axios from 'axios';

const initialState = {
  fileData: null,
  fileErrorMessage: "",
  isLoading: false,
};

export default {
  namespaced: true,
  state: {
    ...initialState,
  },
  mutations: {
    setFileData(state, newValue) {
      state.fileData = newValue;
    },
    setFileErrorMessage(state, newValue) {
      state.fileErrorMessage = newValue;
    },
    setIsLoading(state, newValue) {
      state.isLoading = newValue;
    },
  },
  actions: {
    async getFile({ commit }, { fileId, shouldRedirect = true }) {
        commit('setFileErrorMessage', "");
        commit('setIsLoading', true);
        try {
          const response = await axios.get(`${process.env.VUE_APP_DOCUMENTS_API_BASE_URL}/download/${fileId}`, {
            responseType: 'blob'
          });
          commit('setFileData', {
              fileName: response.headers['x-suggested-filename'],
              data: response.data,
          });
        } catch(error) {
          commit('setFileErrorMessage', "The file has public access restricted.");
          setTimeout(() => {
            commit('setFileErrorMessage', "");
            if (!shouldRedirect) return;
            location.href = `${process.env.VUE_APP_CRM_URL}/dashboard`;
          }, 2000);
        } finally {
          commit('setIsLoading', false);
        }
    },
  },
};
